export var SHARE_MODES;
(function (SHARE_MODES) {
    SHARE_MODES["CHANNEL"] = "channel";
    SHARE_MODES["VIDEO"] = "video";
})(SHARE_MODES || (SHARE_MODES = {}));
//# sourceMappingURL=share-modes.js.map